module.exports = __webpack_public_path__ + "img/haus_new.2e804cc3.svg";